/**
 * Shared page-config reader for application/json script blocks.
 * Usage in PHP: carbuy_page_config([...]) emits <script type="application/json" data-carbuy-page-config>
 */
(function (window, document) {
  'use strict';

  function parseAllConfigs() {
    var merged = {};
    var nodes = document.querySelectorAll('script[type="application/json"][data-carbuy-page-config]');
    for (var i = 0; i < nodes.length; i++) {
      var raw = (nodes[i].textContent || '').trim();
      if (!raw) {
        continue;
      }
      try {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          Object.keys(parsed).forEach(function (key) {
            merged[key] = parsed[key];
          });
        }
      } catch (e) {
        // ignore malformed page config blocks
      }
    }
    return merged;
  }

  var cache = null;

  window.CarbuyPageConfig = {
    get: function (forceRefresh) {
      if (forceRefresh || cache === null) {
        cache = parseAllConfigs();
      }
      return cache;
    },
    getKey: function (key, fallback) {
      var data = this.get();
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        return data[key];
      }
      return fallback;
    },
    /**
     * Apply known config keys onto legacy window globals for gradual migration.
     */
    hydrateLegacyGlobals: function (forceRefresh) {
      var data = this.get(forceRefresh);
      if (!data || typeof data !== 'object') {
        return data;
      }
      if (data.recentSearchesTranslations) {
        window.recentSearchesTranslations = data.recentSearchesTranslations;
      }
      if (data.ProfileI18n) {
        window.ProfileI18n = data.ProfileI18n;
      }
      if (data.CarBuyVehicleTracking) {
        window.CarBuyVehicleTracking = data.CarBuyVehicleTracking;
      }
      if (data.CarBuyLeasingPageContext) {
        window.CarBuyLeasingPageContext = data.CarBuyLeasingPageContext;
      }
      if (data.catalogTranslations) {
        window.catalogTranslations = data.catalogTranslations;
      }
      if (data.catalogSavedFilters) {
        window.catalogSavedFilters = data.catalogSavedFilters;
      }
      if (data.initialCarsData) {
        window.initialCarsData = data.initialCarsData;
      }
      return data;
    },
  };

  window.CarbuyPageConfig.hydrateLegacyGlobals();
  document.addEventListener('DOMContentLoaded', function () {
    window.CarbuyPageConfig.hydrateLegacyGlobals(true);
  });
})(window, document);
